/**
 * Floretti 3.0 — kortingscode toepassen vanuit de winkelmand.
 *
 * Dawn heeft geen codeveld in de mand; Shopify verwacht dat je een code pas
 * in de checkout invoert. Er is wel een route die het server-side afhandelt:
 * /discount/CODE?redirect=... valideert de code en zet hem op de sessie.
 *
 * Een gewoon formulier zou daar ?code=X achter plakken in plaats van de code
 * in het pad te zetten. Daarom vangen we de submit af en bouwen we de juiste
 * URL. De formulieractie blijft wel een geldige, gelokaliseerde Shopify-route
 * zodat de gebruiker nooit op een samengestelde 404-URL belandt.
 */
(function () {
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-cart-promo]');
    if (!form) return;

    const veld = form.querySelector('input[name="code"]');
    const code = (veld && veld.value || '').trim();
    if (!code) return;

    event.preventDefault();

    const root = form.getAttribute('action').replace(/discount\/?$/, '').replace(/\/+$/, '');
    const localizedRoot = root ? `${root}/` : '/';
    const terug = encodeURIComponent(`${localizedRoot}cart`);
    window.location.href = `${localizedRoot}discount/${encodeURIComponent(code)}?redirect=${terug}`;
  });
})();
